/**
 * Prefer using Material Icons. Use custom SVGs only when you cannot find equivalent in MD.
 * All list of possible icons: https://react-icons.netlify.com/#/icons/md
 */
import * as MaterialIcons from 'react-icons/md';
/**
 * Only import custom icons, when you cannot find one in `Material Icon` list (see above).
 */

import AppleStore from './files/apple-store.svg';
import GoogleStore from './files/google-store.svg';
import SortBoth from './files/sort-both.svg';
import SortDown from './files/sort-down.svg';
import SortUp from './files/sort-up.svg';
import CheckCircleOutline from './files/check-circle-outline.svg';
import AccountCircleWhiteBg from './files/account-circle-white-bg.svg';
import AccountSuccess from './files/account-success.svg';
import HelpWhiteBg from './files/help-white-bg.svg';
import HomeWhiteBg from './files/home-white-bg.svg';
import PersonPin from './files/person-pin.svg';
import PersonPinOutline from './files/person-pin-outline.svg';
import PersonPinWhiteBg from './files/person-pin-white-bg.svg';
import Filter from './files/filter.svg';
import UserDisclaimer from './files/user-disclaimer.svg';
import ErrorTriangle from './files/error-triangle.svg';
import FileText from './files/file-text.svg';
import FileTextOutline from './files/file-text-outline.svg';
import FilePdf from './files/file-pdf.svg';
import FileExcel from './files/file-excel.svg';
import Requested from './files/requested.svg';
import ToggleOn from './files/toggle-on.svg';
import ToggleOff from './files/toggle-off.svg';
import Facility from './files/facility.svg';
import Confirm from './files/confirm.svg';
import Shifts from './files/shifts.svg';
import Trash from './files/trash.svg';
import FileDoc from './files/file-doc.svg';
import FileGif from './files/file-gif.svg';
import FileJpg from './files/file-jpg.svg';
import FilePng from './files/file-png.svg';
import FilePpt from './files/file-ppt.svg';
import FileXls from './files/file-xls.svg';
import FileGeneric from './files/file-generic.svg';
import Chart from './files/chart.svg';
import Devices from './files/devices.svg';
import AppHub from './files/app-hub.svg';
import Logout from './files/logout.svg';
import ListAlt from './files/list-alt.svg';
import ApplePodcasts from './files/apple-podcasts.svg';
import GooglePodcasts from './files/google-podcasts.svg';
import Spotify from './files/spotify.svg';
import Linkedin from './files/linkedin.svg';
import Facebook from './files/facebook.svg';
import Twitter from './files/twitter.svg';
import Youtube from './files/youtube.svg';
import Pulse from './files/pulse.svg';
import Description from './files/description.svg';
import Attachment from './files/attachment.svg';
import Flag from './files/flag.svg';
import FlagFilled from './files/flag-filled.svg';
import Pin from './files/pin.svg';
import PinFilled from './files/pin-filled.svg';
import PinLocked from './files/pin-locked.svg';
import PinOff from './files/pin-off.svg';
import MicOffOut from './files/mic-off-out.svg';
import VideocamOffOut from './files/videocam-off-out.svg';
import Flip from './files/flip.svg';
import AdminPortal from './files/admin-portal.svg';
import AdminPortalWhite from './files/admin-portal-white.svg';
import Telemed from './files/telemed-filled.svg';
import Broadcast from './files/broadcast.svg';
import ShiftsFilled from './files/shifts-filled.svg';
import ShiftsOutline from './files/shifts-outline.svg';
import ShiftsEdit from './files/shifts-edit.svg';
import ShiftsCancel from './files/shifts-cancel.svg';
import OutlineVisibility from './files/outline-visibility.svg';
import ScheduleRequest from './files/schedule-request.svg';
import ScheduleRequestOutline from './files/schedule-request-outline.svg';
import ScheduleSuccess from './files/schedule-success.svg';
import ScheduleCancel from './files/schedule-cancel.svg';
import Dot from './files/dot.svg';
import CheckShieldOutline from './files/check-shield-outline.svg';
import PharmacyOutline from './files/pharmacy-outline.svg';
import Lightbulb from './files/lightbulb.svg';
import LockOutline from './files/lock-outline.svg';
import NavigationBurger from './files/hamburger.svg';
import Prescription from './files/prescription.svg';
import PrescriptionOutline from './files/prescription-outline.svg';
import DoNotDisturbOn from './files/do-not-disturb-on.svg';
import DoNotDisturbOnOutline from './files/do-not-disturb-on-outline.svg';
import Dollar from './files/dollar.svg';
import RequestSubmitted from './files/request-submitted.svg';
import RequestSubmittedOutline from './files/request-submitted-outline.svg';
import Rocket from './files/rocket.svg';
import DoubleChevronRight from './files/double-chevron-right.svg';
import SCPHealIcon from './files/scp-heal-icon.svg';
import SCPHealIconText from './files/scp-heal-icon-text.svg';
import SCPHealLogo from './files/scp-heal-logo.svg';
import SCPHealLogoText from './files/scp-heal-logo-text.svg';
import SCPHealthLogo from './files/scp-health-logo.svg';
import SCPHealthLogoText from './files/scp-health-logo-text.svg';
import SCPHealthLogoWhiteText from './files/scp-health-logo-white-text.svg';
import SCPConnectIcon from './files/scp-connect-icon.svg';
import SCPConnectIconText from './files/scp-connect-icon-text.svg';
import SCPConnectLogo from './files/scp-connect-logo.svg';
import SCPConnectLogoText from './files/scp-connect-logo-text.svg';
import SCPPracticeIcon from './files/scp-practice-icon.svg';
import SCPPracticeIconText from './files/scp-practice-icon-text.svg';
import SCPPracticeLogo from './files/scp-practice-logo.svg';
import SCPPracticeLogoText from './files/scp-practice-logo-text.svg';
import SCPCareLogoText from './files/scp-care-logo-text.svg';
import SCPCareLogo from './files/scp-care-logo.svg';
import SCPCareIconText from './files/scp-care-icon-text.svg';
import SCPCareIcon from './files/scp-care-icon.svg';
import SCPClientPortalLogoText from './files/scp-client-portal-logo-text.svg';
import SCPClientPortalIconText from './files/scp-client-portal-icon-text.svg';
/**
 * For any icons (material or custom), the key should be in kebab-case: `my-icon`.
 * Material Icons: `'account-box': MaterialIcons.MdAccountBox`.
 * Custom Icons: `'my-icon': MyIcon`.
 */

export var iconMap = {
  'arrow-drop-down': MaterialIcons.MdArrowDropDown,
  'arrow-forward': MaterialIcons.MdArrowForward,
  'arrow-expand-more': MaterialIcons.MdExpandMore,
  'arrow-expand-less': MaterialIcons.MdExpandLess,
  add: MaterialIcons.MdAdd,
  broadcast: Broadcast,
  edit: MaterialIcons.MdEdit,
  warning: MaterialIcons.MdWarning,
  'google-store': GoogleStore,
  'apple-store': AppleStore,
  check: MaterialIcons.MdCheck,
  clear: MaterialIcons.MdClear,
  'check-box': MaterialIcons.MdCheckBox,
  'check-box-outline-blank': MaterialIcons.MdCheckBoxOutlineBlank,
  'indeterminate-check-box': MaterialIcons.MdIndeterminateCheckBox,
  'sort-down': SortDown,
  'sort-up': SortUp,
  'sort-both': SortBoth,
  'check-circle-outline': CheckCircleOutline,
  error: MaterialIcons.MdError,
  'error-outline': MaterialIcons.MdErrorOutline,
  'keyboard-arrow-left': MaterialIcons.MdKeyboardArrowLeft,
  'keyboard-arrow-right': MaterialIcons.MdKeyboardArrowRight,
  'arrow-back': MaterialIcons.MdArrowBack,
  close: MaterialIcons.MdClose,
  settings: MaterialIcons.MdSettings,
  'settings-outline': MaterialIcons.MdOutlineSettings,
  search: MaterialIcons.MdSearch,
  'exit-to-app': MaterialIcons.MdExitToApp,
  'account-circle': MaterialIcons.MdAccountCircle,
  'account-circle-white-bg': AccountCircleWhiteBg,
  'account-success': AccountSuccess,
  help: MaterialIcons.MdHelp,
  'help-white-bg': HelpWhiteBg,
  'help-outline': MaterialIcons.MdHelpOutline,
  home: MaterialIcons.MdHome,
  'home-white-bg': HomeWhiteBg,
  'person-pin': PersonPin,
  'person-pin-outline': PersonPinOutline,
  'person-pin-white-bg': PersonPinWhiteBg,
  'radio-button-checked': MaterialIcons.MdRadioButtonChecked,
  'radio-button-unchecked': MaterialIcons.MdRadioButtonUnchecked,
  visibility: MaterialIcons.MdVisibility,
  'visibility-off': MaterialIcons.MdVisibilityOff,
  done: MaterialIcons.MdDone,
  'check-circle': MaterialIcons.MdCheckCircle,
  cancel: MaterialIcons.MdCancel,
  person: MaterialIcons.MdPerson,
  'location-city': MaterialIcons.MdLocationCity,
  people: MaterialIcons.MdPeople,
  filter: Filter,
  'swap-horiz': MaterialIcons.MdSwapHoriz,
  'more-vert': MaterialIcons.MdMoreVert,
  description: Description,
  email: MaterialIcons.MdEmail,
  'email-outline': MaterialIcons.MdOutlineEmail,
  launch: MaterialIcons.MdLaunch,
  refresh: MaterialIcons.MdRefresh,
  history: MaterialIcons.MdHistory,
  'user-disclaimer': UserDisclaimer,
  feedback: MaterialIcons.MdAssignmentReturn,
  facility: Facility,
  print: MaterialIcons.MdPrint,
  'error-triangle': ErrorTriangle,
  timelapse: MaterialIcons.MdTimelapse,
  'remove-circle-outline': MaterialIcons.MdRemoveCircleOutline,
  'file-text': FileText,
  'file-text-outline': FileTextOutline,
  'keyboard-arrow-down': MaterialIcons.MdKeyboardArrowDown,
  'keyboard-arrow-up': MaterialIcons.MdKeyboardArrowUp,
  download: MaterialIcons.MdFileDownload,
  'file-pdf': FilePdf,
  'file-excel': FileExcel,
  'stay-current-portrait': MaterialIcons.MdStayCurrentPortrait,
  place: MaterialIcons.MdPlace,
  'watch-later': MaterialIcons.MdWatchLater,
  requested: Requested,
  schedule: MaterialIcons.MdSchedule,
  shifts: Shifts,
  trash: Trash,
  message: MaterialIcons.MdMessage,
  'message-outline': MaterialIcons.MdOutlineMessage,
  'toggle-on': ToggleOn,
  'toggle-off': ToggleOff,
  work: MaterialIcons.MdWork,
  publish: MaterialIcons.MdPublish,
  confirm: Confirm,
  'file-doc': FileDoc,
  'file-gif': FileGif,
  'file-jpg': FileJpg,
  'file-png': FilePng,
  'file-ppt': FilePpt,
  'file-xls': FileXls,
  'file-generic': FileGeneric,
  'file-upload': MaterialIcons.MdFileUpload,
  info: MaterialIcons.MdInfo,
  'info-outline': MaterialIcons.MdInfoOutline,
  'file-download': MaterialIcons.MdFileDownload,
  'file-download-outline': MaterialIcons.MdOutlineFileDownload,
  chart: Chart,
  restore: MaterialIcons.MdRestore,
  devices: Devices,
  'app-hub': AppHub,
  logout: Logout,
  'notifications-none': MaterialIcons.MdNotificationsNone,
  hospital: MaterialIcons.MdLocalHospital,
  'hospital-outline': MaterialIcons.MdOutlineLocalHospital,
  'list-alt': ListAlt,
  'contact-mail': MaterialIcons.MdContactMail,
  web: MaterialIcons.MdWeb,
  'apple-podcasts': ApplePodcasts,
  'google-podcasts': GooglePodcasts,
  spotify: Spotify,
  linkedin: Linkedin,
  facebook: Facebook,
  twitter: Twitter,
  youtube: Youtube,
  pulse: Pulse,
  'event-note': MaterialIcons.MdEventNote,
  attachment: Attachment,
  send: MaterialIcons.MdSend,
  link: MaterialIcons.MdLink,
  'end-call': MaterialIcons.MdCallEnd,
  flag: Flag,
  'flag-filled': FlagFilled,
  pin: Pin,
  'pin-off': PinOff,
  'pin-filled': PinFilled,
  'pin-locked': PinLocked,
  lock: MaterialIcons.MdLock,
  'lock-outline': LockOutline,
  reply: MaterialIcons.MdReply,
  mic: MaterialIcons.MdMic,
  'mic-off-out': MicOffOut,
  sync: MaterialIcons.MdSync,
  videocam: MaterialIcons.MdVideocam,
  'videocam-off-out': VideocamOffOut,
  speaker: MaterialIcons.MdSpeaker,
  'volume-up': MaterialIcons.MdVolumeUp,
  flip: Flip,
  'admin-portal': AdminPortal,
  'admin-portal-white': AdminPortalWhite,
  telemed: Telemed,
  'shifts-filled': ShiftsFilled,
  'shifts-outline': ShiftsOutline,
  'shifts-edit': ShiftsEdit,
  'shifts-cancel': ShiftsCancel,
  'account-circle-outline': MaterialIcons.MdOutlineAccountCircle,
  'outline-visibility': OutlineVisibility,
  'place-outline': MaterialIcons.MdOutlineLocationOn,
  'medical-aid-outline': MaterialIcons.MdOutlineMedicalServices,
  'person-outline': MaterialIcons.MdOutlinePersonOutline,
  world: MaterialIcons.MdPublic,
  'schedule-request': ScheduleRequest,
  'schedule-request-outline': ScheduleRequestOutline,
  'schedule-success': ScheduleSuccess,
  'schedule-cancel': ScheduleCancel,
  'request-submitted': RequestSubmitted,
  'request-submitted-outline': RequestSubmittedOutline,
  'do-not-disturb-on': DoNotDisturbOn,
  'do-not-disturb-on-outline': DoNotDisturbOnOutline,
  dot: Dot,
  'check-shield-outline': CheckShieldOutline,
  'pharmacy-outline': PharmacyOutline,
  lightbulb: Lightbulb,
  'phone-outline': MaterialIcons.MdOutlinePhone,
  'navigation-burger': NavigationBurger,
  prescription: Prescription,
  'prescription-ouline': PrescriptionOutline,
  'pending-outline': MaterialIcons.MdOutlinePending,
  dollar: Dollar,
  'unarchive-outline': MaterialIcons.MdOutlineUnarchive,
  rocket: Rocket,
  'double-chevron-right': DoubleChevronRight,
  'scp-heal-icon': SCPHealIcon,
  'scp-heal-icon-text': SCPHealIconText,
  'scp-heal-logo': SCPHealLogo,
  'scp-heal-logo-text': SCPHealLogoText,
  'scp-health-logo': SCPHealthLogo,
  'scp-health-logo-text': SCPHealthLogoText,
  'scp-health-logo-white-text': SCPHealthLogoWhiteText,
  'scp-connect-icon': SCPConnectIcon,
  'scp-connect-icon-text': SCPConnectIconText,
  'scp-connect-logo': SCPConnectLogo,
  'scp-connect-logo-text': SCPConnectLogoText,
  'scp-practice-icon': SCPPracticeIcon,
  'scp-practice-icon-text': SCPPracticeIconText,
  'scp-practice-logo': SCPPracticeLogo,
  'scp-practice-logo-text': SCPPracticeLogoText,
  'scp-care-logo-text': SCPCareLogoText,
  'scp-care-logo': SCPCareLogo,
  'scp-care-icon-text': SCPCareIconText,
  'scp-care-icon': SCPCareIcon,
  'scp-client-portal-logo-text': SCPClientPortalLogoText,
  'scp-client-portal-icon-text': SCPClientPortalIconText
};